import React from "react";

const Welcome = () => (
  <section className="ftco-section">
    <div className="container">
      <div className="row justify-content-center mb-5 pb-1">
        <div className="col-md-7 heading-section text-center ftco-animate">
          <span className="subheading">Bienvenue à Songon Park</span>
          <h2 className="mb-4">Venez et rêvez éveillé</h2>
        </div>
      </div>
      <div
        className="row"
        style={{
          border: "20px solid #2e9f26",
          padding: "50px"
        }}
      >
        <p
          style={{
            letterSpacing: "5px"
          }}
        >
        </p>
          SONGON PARK
        <div className="row">
          <div className="col">
            <h3
              style={{
                fontSize: "3em",
                lineHeight: "50px",
                fontWeight: "bold"
              }}
            >
              Tout y est pour que votre séjour soit parfait
            </h3>
            <br />
            <p
              style={{
                fontSize: "1.1em",
                textAlign: "justify"
              }}
            >
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero
              atque provident id iste. Assumenda, minima. Excepturi mollitia
              eligendi labore voluptates doloremque velit veritatis iure hic
              quis nemo, blanditiis esse repudiandae? Lorem, ipsum dolor sit
              amet consectetur adipisicing elit. Totam praesentium beatae
              tempora, obcaecati et cupiditate! Quia magnam sunt illum
              ullam, sequi quos optio hic libero alias rem possimus
              molestias facilis?
            </p>
          </div>
          <div className="col">
            <p
              style={{
                fontSize: "1.1em",
                color: "#fff",
                textAlign: "justify"
              }}
            >
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero
              atque provident id iste. Assumenda, minima. Excepturi mollitia
              eligendi labore voluptates doloremque velit veritatis iure hic
              quis Lorem ipsum dolor{" "}
            </p>
            <p
              style={{
                fontSize: "1.1em"
              }}
            >
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero
              atque provident id iste. Assumenda, minima. Excepturi mollitia
              veritatis iure hic quis Lorem ipsum dolor sit amet consectetur
              adipisicing elit amet consectetur adipisicing elit.
            </p>
            <br />
            <a
              href="/rooms"
              className="d-flex align-items-center"
              style={{
                backgroundColor: "#2e9f26",
                height: "60px",
                border: "none",
                padding: "30px",
                color: "#fff",
                fontSize: "1.2em",
                width: "220px",
                letterSpacing: "5px"
              }}
            >
              RESERVATION
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Welcome;